import { createActionGroup, props } from '@ngrx/store';
import { Params } from '@angular/router';

export const appRouterActions = createActionGroup({
  source: 'Router',
  events: {
    'Update Query Params With New Value': props<{ query: Params }>()
  }
});
